
import React from 'react';
import { Card, CardHeader, CardContent, CardFooter, CardTitle, CardDescription } from '@/components/ui/card';
import ConnectionStatus from './ConnectionStatus';
import ConnectionForm from './ConnectionForm';
import ConnectionActions from './ConnectionActions';
import { ActiveDirectoryConfig } from '../../system/types';

interface ActiveDirectoryCardProps {
  adConfig: ActiveDirectoryConfig;
  autoSync: boolean;
  setAutoSync: (value: boolean) => void;
  handleConfigChange: (field: keyof ActiveDirectoryConfig, value: string) => void;
  handleConnect: () => void;
  handleDisconnect: () => void;
  handleSyncNow: () => void;
  editing: boolean;
}

const ActiveDirectoryCard: React.FC<ActiveDirectoryCardProps> = ({
  adConfig,
  autoSync,
  setAutoSync,
  handleConfigChange,
  handleConnect,
  handleDisconnect,
  handleSyncNow,
  editing
}) => {
  return (
    <Card>
      <CardHeader>
        <div className="flex justify-between items-center">
          <div>
            <CardTitle>Active Directory Integration</CardTitle>
            <CardDescription>Configure your Active Directory connection</CardDescription>
          </div>
          <ConnectionStatus adConfig={adConfig} />
        </div>
      </CardHeader>
      <CardContent className="space-y-4">
        <ConnectionForm 
          adConfig={adConfig} 
          autoSync={autoSync} 
          setAutoSync={setAutoSync}
          handleConfigChange={handleConfigChange}
          editing={editing}
        />
      </CardContent>
      <CardFooter className="flex justify-between border-t pt-6">
        <ConnectionActions 
          adConfig={adConfig} 
          editing={editing}
          handleConnect={handleConnect}
          handleDisconnect={handleDisconnect}
          handleSyncNow={handleSyncNow}
        />
      </CardFooter>
    </Card>
  );
};

export default ActiveDirectoryCard;
